export default function (theme) {
    return {
        MuiBottomNavigationAction: {
            root: {
                '&$selected': {
                    borderBottom: `solid 3px ${theme.palette.primary.main}`
                },
                '&:focus': {
                    border: `solid 2px ${theme.palette.secondary.main}`
                },
                '&:hover': {
                    backgroundColor: theme.palette.secondary.light
                }
            }
        }
    };
}
